import Vue from "vue";
import sha256 from 'crypto-js/sha256';

let env = 'dev';
const get_base_url = () => {
  const hostname = window.location.hostname;

  if (hostname.includes('dev.') || hostname.includes('localhost')) {
    env = 'dev';
    return 'https://dev.tma-asigurari.ro/';
  }
  
  if (hostname.includes('stg.')) {
    env = 'staging';
    return 'https://stg.tma-asigurari.ro/';
  }
  
  env = 'production';
  return 'https://tma-asigurari.ro/';
}

const base = get_base_url();


export default {
  version: "1.4",
  BASE_URL: base + "api/index.php/",
  BASE_URL_NO_INDEX: base + "api/",
  baseURL: base + "api/",
  URL_OCR: base + "src/ocr/",
  ENV: env,

  // BASE_URL: "https://dev.tma-asigurari.ro/api/index.php/",
  // BASE_URL_NO_INDEX: "https://dev.tma-asigurari.ro/api/",
  // baseURL: "https://dev.tma-asigurari.ro/api/",
  // URL_OCR: "https://dev.tma-asigurari.ro/src/ocr/",


  set_token: function (newToken) {
    // Token-ul e în cookie HttpOnly setat de server — NU mai stocăm în localStorage.
    if (newToken) {
      window.localStorage.setItem("pca-client-logged", "1");
    } else {
      window.localStorage.removeItem("pca-client-logged");
      window.localStorage.removeItem("pca-asigurari-token");
    }
    delete Vue.http.headers.common["Token"];
  },

  generate_avatar(nume, prenume) {
    return `https://ui-avatars.com/api/?name=${nume}+${prenume}`;
  },

  async downloadHandler(id, tip) {
    const partialLink = "./assets/documente/"; + tip + '/';
    const key = sha256(id.toString() + '!@#.<(%!|#,.#$/');

    window.open(
      this.BASE_URL + "download/download_files?id=" + id + "&link=" + partialLink + "&tip=" + tip + "&key=" + key.toString()
    );

    return;
  },
  async downloadHandlerDecont(id) {
    const partialLink = "./assets/documente/";
    const key = sha256(id.toString() + '!@#.<(%!|#,.#$/');

    window.open(
      this.BASE_URL + "download/download_files?id=" + id + "&link=" + partialLink + "&tip=" + 'decont' + "&key=" + key.toString()
    );

    return;
  },

  get_token: function () {
    // Token-ul real e în cookie HttpOnly (inaccesibil din JS).
    return '';
  },

  set_drepturi: function (drepturi) {
    window.localStorage.setItem(
      "pca-asigurari-drepturi_user",
      JSON.stringify(drepturi)
    );
  },

  get_drepturi: function () {
    var drepturi = window.localStorage.getItem("pca-asigurari-drepturi_user");
    return JSON.parse(drepturi);
  },
  set_user_type: function (user_type) {
    window.localStorage.setItem("pca-asigurari-user_type", user_type);
  },

  get_user_type: function () {
    return window.localStorage.getItem("pca-asigurari-user_type");
  },

  is_logged_in: function () {
    // Cookie-ul HttpOnly nu e citibil din JS — folosim flag-ul setat la login.
    return window.localStorage.getItem("pca-client-logged") === "1";
  },

  logout: function () {
    // Cere serverului să invalideze token-ul și să șteargă cookie-ul.
    if (typeof Vue !== 'undefined' && Vue.http) {
      Vue.http.post(this.BASE_URL + 'client/login/logout').catch(function () {});
    }
    this.set_token("");
    this.set_drepturi("");
    window.localStorage.removeItem("pca-asigurari-user_type");
  },

  redirect_to_homepage(vueInstance) {
    vueInstance.$router.push("/");
  },

  verify_response: function (response) {
    if (response.body.NotLogged) {
      return false;
    }
    return true;
  },

  verify_login_and_redirect: function (vueInstance) {
    if (!this.is_logged_in()) {
      vueInstance.$router.push("/");
    }
  },
};
